import { render, staticRenderFns } from "./edit_advise.vue?vue&type=template&id=f72e9aee&scoped=true&"
import script from "./edit_advise.vue?vue&type=script&lang=js&"
export * from "./edit_advise.vue?vue&type=script&lang=js&"
import style0 from "./edit_advise.vue?vue&type=style&index=0&id=f72e9aee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e9aee",
  null
  
)

export default component.exports